import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

const pickerDateFormat = 'YYYY-M-D';
const uiDateFormat = 'DD/MM/YYYY';

export default {
  name: 'Outcome',
  props: ['dataObj'],
  data: function () {
    return {
      outcomeData: { },
      message: '',
    }
  },
  computed: {
    formattedDate: function () {
      return this.formatDateUI(moment(this.outcomeData.date));
    },
  },
  created() {
    this.$root.$on('investigation_outcome_updated')
    this.init;
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.outcomeData = this.dataObj;
      });
    },
    formatDateUI(date) {
      return moment(date).add(1, 'days').format(uiDateFormat);
    },
    formatDateYYYYMMDD(date) {
      return moment(date, 'YYYY-MM-DD');
    },
  }

}
